export default __webpack_public_path__ + "static/jason-bitmoji-56f12952f0f4882fbfbf8b41a8296f6b.png";